import { createRouter } from "@tanstack/react-router";
import type { AuthPort } from "../features/auth/auth-port";
import { routeTree } from "../routeTree.gen";

/** What every route's beforeLoad receives. */
export interface RouterContext {
  auth: AuthPort;
}

export function createAppRouter(auth: AuthPort) {
  return createRouter({ routeTree, context: { auth }, defaultPreload: "intent" });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
